import React from "react";
import PropTypes from "prop-types";
import ClipboardCopy from '@components/common/clipboard_copy/main';
import '../../styles/org_color_asset_modal.scss';

const renderHex = (hex) => (
  <li>
    <div className="color-value">
      <span>{t('Hex')}:</span>
      <p>#{hex}</p>
    </div>
    <p className="s-copy-color">
      <ClipboardCopy textToCopy={`#${hex}`} check showFeedbackAsTooltip={false}>
        {t('Copy Hex')}
      </ClipboardCopy>
    </p>
  </li>
);

const renderRGB = (assetDataString) => (
  <li>
    <div className="color-value">
      <span>RGB:</span>
      <p>{assetDataString}</p>
    </div>
    <p className="s-copy-color">
      <ClipboardCopy textToCopy={assetDataString} check showFeedbackAsTooltip={false}>
        {t('Copy RGB')}
      </ClipboardCopy>
    </p>
  </li>
);

const renderCMYK = (assetDataString) => (
  <li>
    <div className="color-value">
      <span>CMYK:</span>
      <p>{assetDataString}</p>
    </div>
    <p className="s-copy-color">
      <ClipboardCopy textToCopy={assetDataString} check showFeedbackAsTooltip={false}>
        {t('Copy CMYK')}
      </ClipboardCopy>
    </p>
  </li>
);


const renderPantone = (pantone, pantoneU) => (
  <ul>
    <li>
      <div className="color-value">
        <span>{t('Pantone')}:</span>
        <p>{pantone}</p>
      </div>
      <p className="s-copy-color">
        <ClipboardCopy textToCopy={pantone} showFeedbackAsTooltip={false}>
          {t('Copy Pantone')}
        </ClipboardCopy>
      </p>
    </li>
    <li>
      <div className="color-value">
        <span>{t('Pantone')}:</span>
        <p>{pantoneU}</p>
      </div>
      <p className="s-copy-color">
        {pantoneU
          ? (
            <React.Fragment>
              <ClipboardCopy textToCopy={pantoneU} showFeedbackAsTooltip={false}>
                {t('Copy Pantone')}
              </ClipboardCopy>
            </React.Fragment>
          ) : ""
        }
      </p>
    </li>
  </ul>
);

const ColorDetails = ({ assetData }) => (
  <ul className="m-show-full-display-color color-list">
    {assetData.hex ? renderHex(assetData.hex) : ""}
    {assetData.r && assetData.g && assetData.b ? renderRGB(`${assetData.r} / ${assetData.g} / ${assetData.b}`) : ""}
    { assetData.c
    && assetData.m
    && assetData.y
    && assetData.k ? renderCMYK(`${assetData.c} / ${assetData.m} / ${assetData.y} / ${assetData.k}`) : ""}
    {assetData.pantone ? renderPantone(assetData.pantone, assetData.pantone_u) : ""}
  </ul>
);

ColorDetails.propTypes = {
  assetData: PropTypes.shape({}).isRequired
};

export default ColorDetails;
